import { jsx as _jsx } from "react/jsx-runtime";
import ivclass from '../../Modules/IVClass';
import Feature from './Feature';
const FeaturesList = (props) => {
    const { featuresList, featuresCheckImage, platform, theme = 'light' } = props;
    return (_jsx("div", { className: ivclass('xl:iv-py-15 lg:iv-py-10 md:iv-pt-[22px] sm:iv-pt-5', 'xl:iv-px-20 lg:iv-px-[13px]', 'md:iv-ml-15 sm:iv-ml-8', 'iv-flex-grow'), children: featuresList.map(({ highlightedText, plainText }, index) => (_jsx(Feature, { highlightedText: highlightedText, plainText: plainText, featuresCheckImage: featuresCheckImage, platform: platform, theme: theme }, index))) }));
};
export default FeaturesList;
